import { AiWrapper, AiCriteria, AiScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { Model } from '../../model/model';

/**
 * Appels Réponses IA 
 * Author LMA
 */
export class IaResponseCmd extends WizCommand<AiWrapper> {

  protected model: Model = null;
  
  public static readonly AI_API: string = 'ai.do';

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  /** méthode appelée au retour de la commande */
  public sourceCallback: Function;
  public method: string;

  /** retourne un wrapper pre-alimenté */
  public aiWrapper(): AiWrapper {
    const wrapper: AiWrapper = new AiWrapper();
    wrapper.criteria = new AiCriteria();
    wrapper.scenario = new AiScenario();
    wrapper.criteria.domain = this.model.currentDomainCode;
    // wrapper.criteria.businessUnitCode = this.model.currentBUCode;
    // wrapper.criteria.visionCode = this.model.currentVision?.code || WizConstants.wildcardDomain;
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }


  /** chargement spécifique sur contextGuard */
  public find(sourceCallback: Function = null): IaResponseCmd {
    const wrapper: AiWrapper = this.aiWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    
    this.configureRemote(IaResponseCmd.AI_API, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }
  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    const wrapper: AiWrapper = this.result;
    
    if(!!wrapper) {
      if (wrapper.method === WIZ_COMMAND_METHOD.FIND) {
        this.model.aiResponseCollection = this.result.entities; 
      }
  
      if (this.sourceCallback != null) {
        this.sourceCallback();
      }
    } else {
      console.log('IaResponseCmd error');
    }


  }

}
